import { forwardRef } from "react";
import classNames from "classnames";
import { Tag } from "antd";
import type { CheckableTagProps } from "antd/lib/tag";
import type { GetRef } from "antd/lib";
import styles from "./styles.module.scss";

type CheckableTagRefType = GetRef<typeof Tag.CheckableTag>;

export const CheckableTag = forwardRef<CheckableTagRefType, CheckableTagProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Tag.CheckableTag
        ref={ref}
        className={classNames(styles["checkable-tag"], className)}
        {...props}
      >
        {children}
      </Tag.CheckableTag>
    );
  },
);
